import { createFileRoute } from '@tanstack/react-router';

import { Projects } from '@/features/projects/Projects';
import { ProjectModeProvider } from '@/features/projects/ProjectModeContext';

export const Route = createFileRoute('/_authenticated/fair-quote/')({
  component: function Page() {
    return (
      <ProjectModeProvider value='/fair-quote'>
        <Projects />
      </ProjectModeProvider>
    );
  },
});
